module.exports = __webpack_public_path__ + "img/home-bg.11bf76a9.jpg";